import {
  LinkedHashSetClassDesc202cqq5740j6e as LinkedHashSetClassDesc,
  ArrayListClassDesc2euexqfjnihq7 as ArrayListClassDesc,
  HashSetClassDesc1sva99tssxbb4 as HashSetClassDesc,
  HashMapClassDesc33bep136pd9y6 as HashMapClassDesc,
  LinkedHashMapClassDesc1yxtovbec4ruk as LinkedHashMapClassDesc,
  ArrayClassDesc2voesact8ugbc as ArrayClassDesc,
  PrimitiveArrayDescriptor3bvg9e2uulc3b as PrimitiveArrayDescriptor,
} from './CollectionDescriptors.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  KtSetjrjc7fhfd6b9 as KtSet,
  KtList3hktaavzmj137 as KtList,
  KtMap140uvy3s5zad8 as KtMap,
  Collection1k04j3hzsbod0 as Collection,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isArray1hxjqtqy632bc as isArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { arrayIterator3lgwvgteckzhv as arrayIterator } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  toNativeArrayImpl3ha7yn5cjhfpi as toNativeArrayImpl,
  estimateCapacityForHashMap22j0ug0qzpov2 as estimateCapacityForHashMap,
} from './Platform.mjs';
import {
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { addAll21mdhg523wnoa as addAll } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { PrimitiveKindndgbuh6is7ze as PrimitiveKind } from '../descriptors/SerialKinds.mjs';
import { getValue48kllevslyh6 as getValue } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var LinkedHashSetSerializerClass;
function LinkedHashSetSerializer() {
  if (LinkedHashSetSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(eSerializer) {
        super(eSerializer);
        this.u1u_1 = new (LinkedHashSetClassDesc())(eSerializer.b1n());
      }
      b1n() {
        return this.u1u_1;
      }
      v1u(initialCapacityHint) {
        if (initialCapacityHint === -1) {
          // Inline function 'kotlin.collections.linkedSetOf' call
          return LinkedHashSet().s2();
        }
        return newLinkedHashSet(initialCapacityHint);
      }
      w1u(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      x1u(_this__u8e3s4) {
        return this.w1u(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      y1u(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      z1u(_this__u8e3s4) {
        return this.y1u(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      a1v(_this__u8e3s4, expectedSize) {
        if (_this__u8e3s4 instanceof LinkedHashSet())
          return _this__u8e3s4;
        if (expectedSize <= _this__u8e3s4.q2())
          return LinkedHashSet().c3(_this__u8e3s4);
        // Inline function 'kotlin.also' call
        var this_0 = newLinkedHashSet(expectedSize);
        this_0.u2(_this__u8e3s4);
        return this_0;
      }
      b1v(_this__u8e3s4, expectedSize) {
        return this.a1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet()) : false) ? _this__u8e3s4 : THROW_CCE(), expectedSize);
      }
      c1v(_this__u8e3s4, index, element) {
        _this__u8e3s4.j2(element);
      }
      d1v(_this__u8e3s4, index, element) {
        return this.c1v(_this__u8e3s4 instanceof LinkedHashSet() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'LinkedHashSetSerializer');
    LinkedHashSetSerializerClass = $;
  }
  return LinkedHashSetSerializerClass;
}
var ArrayListSerializerClass;
function ArrayListSerializer() {
  if (ArrayListSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(element) {
        super(element);
        this.o1v_1 = new (ArrayListClassDesc())(element.b1n());
      }
      b1n() {
        return this.o1v_1;
      }
      v1u(initialCapacityHint) {
        if (initialCapacityHint === -1) {
          // Inline function 'kotlin.collections.arrayListOf' call
          return ArrayList().p2();
        }
        return ArrayList().i2(initialCapacityHint);
      }
      p1v(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      x1u(_this__u8e3s4) {
        return this.p1v(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      q1v(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      z1u(_this__u8e3s4) {
        return this.q1v(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      r1v(_this__u8e3s4, expectedSize) {
        if (_this__u8e3s4 instanceof ArrayList()) {
          // Inline function 'kotlin.also' call
          _this__u8e3s4.i8(expectedSize);
          return _this__u8e3s4;
        }
        if (expectedSize === _this__u8e3s4.q2())
          return ArrayList().k2(_this__u8e3s4);
        // Inline function 'kotlin.also' call
        var this_0 = ArrayList().i2(expectedSize);
        this_0.u2(_this__u8e3s4);
        return this_0;
      }
      b1v(_this__u8e3s4, expectedSize) {
        return this.r1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList()) : false) ? _this__u8e3s4 : THROW_CCE(), expectedSize);
      }
      s1v(_this__u8e3s4, index, element) {
        _this__u8e3s4.z4(index, element);
      }
      d1v(_this__u8e3s4, index, element) {
        return this.s1v(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'ArrayListSerializer');
    ArrayListSerializerClass = $;
  }
  return ArrayListSerializerClass;
}
var HashSetSerializerClass;
function HashSetSerializer() {
  if (HashSetSerializerClass === VOID) {
    class $ extends CollectionSerializer() {
      constructor(eSerializer) {
        super(eSerializer);
        this.u1v_1 = new (HashSetClassDesc())(eSerializer.b1n());
      }
      b1n() {
        return this.u1v_1;
      }
      v1u(initialCapacityHint) {
        if (initialCapacityHint === -1)
          return HashSet().ha();
        return newHashSet(initialCapacityHint);
      }
      v1v(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      x1u(_this__u8e3s4) {
        return this.v1v(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      w1v(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      z1u(_this__u8e3s4) {
        return this.w1v(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE());
      }
      a1v(_this__u8e3s4, expectedSize) {
        if (_this__u8e3s4 instanceof HashSet())
          return _this__u8e3s4;
        if (expectedSize <= _this__u8e3s4.q2())
          return HashSet().ia(_this__u8e3s4);
        // Inline function 'kotlin.also' call
        var this_0 = newHashSet(expectedSize);
        this_0.u2(_this__u8e3s4);
        return this_0;
      }
      b1v(_this__u8e3s4, expectedSize) {
        return this.a1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet()) : false) ? _this__u8e3s4 : THROW_CCE(), expectedSize);
      }
      x1v(_this__u8e3s4, index, element) {
        _this__u8e3s4.j2(element);
      }
      d1v(_this__u8e3s4, index, element) {
        return this.x1v(_this__u8e3s4 instanceof HashSet() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'HashSetSerializer');
    HashSetSerializerClass = $;
  }
  return HashSetSerializerClass;
}
var HashMapSerializerClass;
function HashMapSerializer() {
  if (HashMapSerializerClass === VOID) {
    class $ extends MapLikeSerializer() {
      constructor(kSerializer, vSerializer) {
        super(kSerializer, vSerializer);
        this.a1w_1 = new (HashMapClassDesc())(kSerializer.b1n(), vSerializer.b1n());
      }
      b1n() {
        return this.a1w_1;
      }
      b1w(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      c1w(_this__u8e3s4) {
        return this.b1w((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      d1w(_this__u8e3s4) {
        // Inline function 'kotlin.collections.iterator' call
        return _this__u8e3s4.l3().p1();
      }
      e1w(_this__u8e3s4) {
        return this.d1w((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      v1u(initialCapacityHint) {
        if (initialCapacityHint === -1)
          return HashMap().s8();
        return newHashMap(initialCapacityHint);
      }
      f1w(_this__u8e3s4) {
        return imul(_this__u8e3s4.q2(), 2);
      }
      x1u(_this__u8e3s4) {
        return this.f1w(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      g1w(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      z1u(_this__u8e3s4) {
        return this.g1w(_this__u8e3s4 instanceof HashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      h1w(_this__u8e3s4, expectedSize) {
        if (_this__u8e3s4 instanceof HashMap())
          return _this__u8e3s4;
        if (expectedSize <= _this__u8e3s4.q2())
          return HashMap().h9(_this__u8e3s4);
        // Inline function 'kotlin.also' call
        var this_0 = newHashMap(expectedSize);
        this_0.d5(_this__u8e3s4);
        return this_0;
      }
      b1v(_this__u8e3s4, expectedSize) {
        return this.h1w((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE(), expectedSize);
      }
    }
    initMetadataForClass($, 'HashMapSerializer');
    HashMapSerializerClass = $;
  }
  return HashMapSerializerClass;
}
var LinkedHashMapSerializerClass;
function LinkedHashMapSerializer() {
  if (LinkedHashMapSerializerClass === VOID) {
    class $ extends MapLikeSerializer() {
      constructor(kSerializer, vSerializer) {
        super(kSerializer, vSerializer);
        this.o1w_1 = new (LinkedHashMapClassDesc())(kSerializer.b1n(), vSerializer.b1n());
      }
      b1n() {
        return this.o1w_1;
      }
      b1w(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      c1w(_this__u8e3s4) {
        return this.b1w((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      d1w(_this__u8e3s4) {
        // Inline function 'kotlin.collections.iterator' call
        return _this__u8e3s4.l3().p1();
      }
      e1w(_this__u8e3s4) {
        return this.d1w((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      v1u(initialCapacityHint) {
        if (initialCapacityHint === -1)
          return LinkedHashMap().fc();
        return newLinkedHashMap(initialCapacityHint);
      }
      p1w(_this__u8e3s4) {
        return imul(_this__u8e3s4.q2(), 2);
      }
      x1u(_this__u8e3s4) {
        return this.p1w(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      q1w(_this__u8e3s4) {
        return _this__u8e3s4;
      }
      z1u(_this__u8e3s4) {
        return this.q1w(_this__u8e3s4 instanceof LinkedHashMap() ? _this__u8e3s4 : THROW_CCE());
      }
      h1w(_this__u8e3s4, expectedSize) {
        if (_this__u8e3s4 instanceof LinkedHashMap())
          return _this__u8e3s4;
        if (expectedSize <= _this__u8e3s4.q2())
          return LinkedHashMap().hc(_this__u8e3s4);
        // Inline function 'kotlin.also' call
        var this_0 = newLinkedHashMap(expectedSize);
        this_0.d5(_this__u8e3s4);
        return this_0;
      }
      b1v(_this__u8e3s4, expectedSize) {
        return this.h1w((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap()) : false) ? _this__u8e3s4 : THROW_CCE(), expectedSize);
      }
    }
    initMetadataForClass($, 'LinkedHashMapSerializer');
    LinkedHashMapSerializerClass = $;
  }
  return LinkedHashMapSerializerClass;
}
var ReferenceArraySerializerClass;
function ReferenceArraySerializer() {
  if (ReferenceArraySerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      constructor(kClass, eSerializer) {
        super(eSerializer);
        this.s1w_1 = kClass;
        this.t1w_1 = new (ArrayClassDesc())(eSerializer.b1n());
      }
      b1n() {
        return this.t1w_1;
      }
      u1w(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      c1w(_this__u8e3s4) {
        return this.u1w((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      v1w(_this__u8e3s4) {
        return arrayIterator(_this__u8e3s4);
      }
      e1w(_this__u8e3s4) {
        return this.v1w((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      v1u(initialCapacityHint) {
        if (initialCapacityHint === -1) {
          // Inline function 'kotlin.collections.arrayListOf' call
          return ArrayList().p2();
        }
        return ArrayList().i2(initialCapacityHint);
      }
      w1w(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      x1u(_this__u8e3s4) {
        return this.w1w(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      x1w(_this__u8e3s4) {
        return toNativeArrayImpl(_this__u8e3s4, this.s1w_1);
      }
      z1u(_this__u8e3s4) {
        return this.x1w(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE());
      }
      y1w(_this__u8e3s4, expectedSize) {
        var expectedCapacity = coerceAtLeast(expectedSize, 0);
        // Inline function 'kotlin.also' call
        var this_0 = ArrayList().i2(expectedCapacity);
        addAll(this_0, _this__u8e3s4);
        return this_0;
      }
      b1v(_this__u8e3s4, expectedSize) {
        return this.y1w((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE(), expectedSize);
      }
      z1w(_this__u8e3s4, index, element) {
        _this__u8e3s4.z4(index, element);
      }
      d1v(_this__u8e3s4, index, element) {
        return this.z1w(_this__u8e3s4 instanceof ArrayList() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
    }
    initMetadataForClass($, 'ReferenceArraySerializer');
    ReferenceArraySerializerClass = $;
  }
  return ReferenceArraySerializerClass;
}
var CollectionSerializerClass;
function CollectionSerializer() {
  if (CollectionSerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      f1v(_this__u8e3s4) {
        return _this__u8e3s4.q2();
      }
      c1w(_this__u8e3s4) {
        return this.f1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      g1v(_this__u8e3s4) {
        return _this__u8e3s4.p1();
      }
      e1w(_this__u8e3s4) {
        return this.g1v((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
    }
    initMetadataForClass($, 'CollectionSerializer');
    CollectionSerializerClass = $;
  }
  return CollectionSerializerClass;
}
function newLinkedHashSet(expectedCapacity) {
  var capacity = estimateCapacityForHashMap(expectedCapacity);
  return LinkedHashSet().e2(capacity);
}
function newHashSet(expectedCapacity) {
  var capacity = estimateCapacityForHashMap(expectedCapacity);
  return HashSet().e3(capacity);
}
var MapLikeSerializerClass;
function MapLikeSerializer() {
  if (MapLikeSerializerClass === VOID) {
    class $ extends AbstractCollectionSerializer() {
      constructor(keySerializer, valueSerializer) {
        super();
        this.i1w_1 = keySerializer;
        this.j1w_1 = valueSerializer;
      }
      k1w(decoder, builder, startIndex, size) {
        // Inline function 'kotlin.require' call
        if (!(size >= 0)) {
          var message = 'Size must be known in advance when using READ_ALL';
          throw IllegalArgumentException().o2(toString(message));
        }
        var progression = step(until(0, imul(size, 2)), 2);
        var inductionVariable = progression.q3_1;
        var last = progression.r3_1;
        var step_0 = progression.s3_1;
        if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + step_0 | 0;
            this.l1w(decoder, startIndex + index | 0, builder, false);
          }
           while (!(index === last));
      }
      j1v(decoder, builder, startIndex, size) {
        return this.k1w(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap()) : false) ? builder : THROW_CCE(), startIndex, size);
      }
      l1w(decoder, index, builder, checkIndex) {
        var key = decoder.f1s(this.b1n(), index, this.i1w_1);
        var tmp;
        if (checkIndex) {
          // Inline function 'kotlin.also' call
          var this_0 = decoder.j1s(this.b1n());
          // Inline function 'kotlin.require' call
          if (!(this_0 === (index + 1 | 0))) {
            var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
            throw IllegalArgumentException().o2(toString(message));
          }
          tmp = this_0;
        } else {
          tmp = index + 1 | 0;
        }
        var vIndex = tmp;
        var tmp_0;
        var tmp_1;
        if (builder.t4(key)) {
          var tmp_2 = this.j1w_1.b1n().x1p();
          tmp_1 = !(tmp_2 instanceof PrimitiveKind());
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = decoder.e1s(this.b1n(), vIndex, this.j1w_1, getValue(builder, key));
        } else {
          tmp_0 = decoder.f1s(this.b1n(), vIndex, this.j1w_1);
        }
        var value = tmp_0;
        // Inline function 'kotlin.collections.set' call
        builder.b5(key, value);
      }
      k1v(decoder, index, builder, checkIndex) {
        return this.l1w(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap()) : false) ? builder : THROW_CCE(), checkIndex);
      }
      i1v(encoder, value) {
        var size = this.c1w(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.b1n();
        var composite = encoder.p1t(descriptor, size);
        var iterator = this.e1w(value);
        var index = 0;
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = iterator;
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          // Inline function 'kotlin.collections.component1' call
          var k = element.m3();
          // Inline function 'kotlin.collections.component2' call
          var v = element.n3();
          var tmp = this.b1n();
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          composite.k1t(tmp, _unary__edvuaz, this.i1w_1, k);
          var tmp_0 = this.b1n();
          var _unary__edvuaz_0 = index;
          index = _unary__edvuaz_0 + 1 | 0;
          composite.k1t(tmp_0, _unary__edvuaz_0, this.j1w_1, v);
        }
        composite.t1r(descriptor);
      }
      c1n(encoder, value) {
        return this.i1v(encoder, value);
      }
    }
    initMetadataForClass($, 'MapLikeSerializer');
    MapLikeSerializerClass = $;
  }
  return MapLikeSerializerClass;
}
function newHashMap(expectedCapacity) {
  var capacity = estimateCapacityForHashMap(expectedCapacity);
  return HashMap().g9(capacity);
}
function newLinkedHashMap(expectedCapacity) {
  var capacity = estimateCapacityForHashMap(expectedCapacity);
  return LinkedHashMap().gc(capacity);
}
var CollectionLikeSerializerClass;
function CollectionLikeSerializer() {
  if (CollectionLikeSerializerClass === VOID) {
    class $ extends AbstractCollectionSerializer() {
      constructor(elementSerializer) {
        super();
        this.h1v_1 = elementSerializer;
      }
      i1v(encoder, value) {
        var size = this.c1w(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.b1n();
        var composite = encoder.p1t(descriptor, size);
        var iterator = this.e1w(value);
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            composite.k1t(this.b1n(), index, this.h1v_1, iterator.r1());
          }
           while (inductionVariable < size);
        composite.t1r(descriptor);
      }
      c1n(encoder, value) {
        return this.i1v(encoder, value);
      }
      j1v(decoder, builder, startIndex, size) {
        // Inline function 'kotlin.require' call
        if (!(size >= 0)) {
          var message = 'Size must be known in advance when using READ_ALL';
          throw IllegalArgumentException().o2(toString(message));
        }
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.k1v(decoder, startIndex + index | 0, builder, false);
          }
           while (inductionVariable < size);
      }
      k1v(decoder, index, builder, checkIndex) {
        this.d1v(builder, index, decoder.f1s(this.b1n(), index, this.h1v_1));
      }
    }
    initMetadataForClass($, 'CollectionLikeSerializer');
    CollectionLikeSerializerClass = $;
  }
  return CollectionLikeSerializerClass;
}
var AbstractCollectionSerializerClass;
function AbstractCollectionSerializer() {
  if (AbstractCollectionSerializerClass === VOID) {
    class $ {
      m1v(decoder, previous) {
        var compositeDecoder = decoder.s1r(this.b1n());
        var expectedSize = compositeDecoder.k1s(this.b1n());
        // Inline function 'kotlin.require' call
        if (!(expectedSize >= -1)) {
          var message = 'Decoded collection size should be either non-negative, or -1 (meaning, unknown). Was: ' + expectedSize;
          throw IllegalArgumentException().o2(toString(message));
        }
        var tmp;
        if (!(previous == null)) {
          tmp = this.b1v(previous, this.c1w(previous) + coerceAtLeast(expectedSize, 0) | 0);
        } else {
          tmp = this.v1u(expectedSize);
        }
        var builder = tmp;
        var startIndex = this.x1u(builder);
        if (compositeDecoder.i1s()) {
          this.j1v(compositeDecoder, builder, startIndex, expectedSize);
        } else {
          $l$loop: while (true) {
            var index = compositeDecoder.j1s(this.b1n());
            if (index === -1)
              break $l$loop;
            this.l1v(compositeDecoder, startIndex + index | 0, builder);
          }
        }
        compositeDecoder.t1r(this.b1n());
        return this.z1u(builder);
      }
      d1n(decoder) {
        return this.m1v(decoder, null);
      }
      l1v(decoder, index, builder, checkIndex, $super) {
        checkIndex = checkIndex === VOID ? true : checkIndex;
        var tmp;
        if ($super === VOID) {
          this.k1v(decoder, index, builder, checkIndex);
          tmp = Unit_instance;
        } else {
          tmp = $super.k1v.call(this, decoder, index, builder, checkIndex);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer()]);
    AbstractCollectionSerializerClass = $;
  }
  return AbstractCollectionSerializerClass;
}
var PrimitiveArraySerializerClass;
function PrimitiveArraySerializer() {
  if (PrimitiveArraySerializerClass === VOID) {
    class $ extends CollectionLikeSerializer() {
      constructor(primitiveSerializer) {
        super(primitiveSerializer);
        this.b1x_1 = new (PrimitiveArrayDescriptor())(primitiveSerializer.b1n());
      }
      b1n() {
        return this.b1x_1;
      }
      c1x(_this__u8e3s4) {
        return _this__u8e3s4.d1x();
      }
      x1u(_this__u8e3s4) {
        return this.c1x(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE());
      }
      e1x(_this__u8e3s4) {
        return _this__u8e3s4.f1x();
      }
      z1u(_this__u8e3s4) {
        return this.e1x(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE());
      }
      g1x(_this__u8e3s4) {
        // Inline function 'kotlin.error' call
        var message = 'This method lead to boxing and must not be used, use writeContents instead';
        throw IllegalStateException().o(toString(message));
      }
      e1w(_this__u8e3s4) {
        return this.g1x(_this__u8e3s4);
      }
      h1x(_this__u8e3s4, index, element) {
        // Inline function 'kotlin.error' call
        var message = 'This method lead to boxing and must not be used, use Builder.append instead';
        throw IllegalStateException().o(toString(message));
      }
      d1v(_this__u8e3s4, index, element) {
        return this.h1x(_this__u8e3s4 instanceof PrimitiveArrayBuilder() ? _this__u8e3s4 : THROW_CCE(), index, element);
      }
      v1u(initialCapacityHint) {
        if (initialCapacityHint === -1)
          return this.i1x();
        return this.j1x(initialCapacityHint);
      }
      m1x(encoder, value) {
        var size = this.c1w(value);
        // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
        var descriptor = this.b1x_1;
        var composite = encoder.p1t(descriptor, size);
        this.l1x(composite, value, size);
        composite.t1r(descriptor);
      }
      c1n(encoder, value) {
        return this.m1x(encoder, value);
      }
      i1v(encoder, value) {
        return this.m1x(encoder, value);
      }
      d1n(decoder) {
        return this.m1v(decoder, null);
      }
    }
    initMetadataForClass($, 'PrimitiveArraySerializer');
    PrimitiveArraySerializerClass = $;
  }
  return PrimitiveArraySerializerClass;
}
var PrimitiveArrayBuilderClass;
function PrimitiveArrayBuilder() {
  if (PrimitiveArrayBuilderClass === VOID) {
    class $ {
      static n1x() {
        return createThis(this);
      }
      p1x(requiredCapacity, $super) {
        requiredCapacity = requiredCapacity === VOID ? this.d1x() + 1 | 0 : requiredCapacity;
        var tmp;
        if ($super === VOID) {
          this.o1x(requiredCapacity);
          tmp = Unit_instance;
        } else {
          tmp = $super.o1x.call(this, requiredCapacity);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'PrimitiveArrayBuilder');
    PrimitiveArrayBuilderClass = $;
  }
  return PrimitiveArrayBuilderClass;
}
//region block: exports
export {
  ArrayListSerializer as ArrayListSerializer7k5wnrulb3y6,
  HashMapSerializer as HashMapSerializer10v33y6rrzgrh,
  HashSetSerializer as HashSetSerializer1nieavib0jif1,
  LinkedHashMapSerializer as LinkedHashMapSerializermaoj2nyji7op,
  LinkedHashSetSerializer as LinkedHashSetSerializer3ncla559t2lx7,
  PrimitiveArrayBuilder as PrimitiveArrayBuilder1tzna3i4eqw54,
  PrimitiveArraySerializer as PrimitiveArraySerializer6xcmeltdozbx,
  ReferenceArraySerializer as ReferenceArraySerializer3juj1vqolxkrs,
};
//endregion

//# sourceMappingURL=CollectionSerializers.mjs.map
